var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".file_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "file_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "file_svg__st1",
    d: "M17.03 5.01v12c0 2.77-2.26 5.03-5.03 5.03s-5.03-2.26-5.03-5.03V4.99c0-1.67 1.36-3.03 3.03-3.03s3.03 1.36 3.03 3.03v9.02c0 .56-.46 1.02-1.02 1.02s-1.02-.46-1.02-1.02V6.02H9.03v7.99c0 1.65 1.34 2.98 2.98 2.98s2.98-1.34 2.98-2.98V4.99C14.99 2.24 12.75 0 10 0S5.01 2.24 5.01 4.99v12.02C5.01 20.86 8.15 24 12 24c3.86 0 6.99-3.14 6.99-6.99v-12h-1.96z"
  })));
};
export default SvgFile;